import React, {useState, useEffect, memo, useCallback} from "react";
import Card from "../Card";
import Filter from "../Filter";
import "./cardlist.sass";
import {formatAmount, isArr} from "../../utils"
const {Translations: {filters}} = window;

const filtersFromData = {};


Object.entries(filters.main).map(entry => {
    if(entry[0] === "insets") {
        return filtersFromData[entry[0]] = null
    }
    return filtersFromData[entry[0]] = []
});

const CardList = ({items}) => {
    const [cardItems, setCardItems] = useState([...items]);
    const [priceFilter, setPriceFilter] = useState("");
    const [isFilterOpen, setIsShown] = useState(false);
    const [filterCount, setFiltersCount] = useState(0);
    const toggle = useCallback(() =>  setIsShown(!isFilterOpen), [isFilterOpen]);
    const [appliedFilter, setApliedFilter] = useState(filtersFromData);

    const handlePriceFilter = () => {
        switch (priceFilter) {
            case "": {
                return setPriceFilter("max");
            }

            case "max":{
                return setPriceFilter("min");
            }

            case "min": {
                return setPriceFilter("");
            }

            default: {
                return setPriceFilter("");
            }

        }
    };

    const handleOptionClick = (type, value) => {
        const isNumber = typeof value === "number";

        if(isNumber){
            const hasValue = appliedFilter[type].includes(value);
            return setApliedFilter({
                ...appliedFilter,
                [type]: hasValue ? appliedFilter[type].filter(item => item !== value) : [...appliedFilter[type], value]
            })
        }else{
            const isAlreadySet = appliedFilter[type] === value;
            return setApliedFilter({
                ...appliedFilter,
                [type]: isAlreadySet ? null : value
            })
        }
    };

    useEffect(() => {
        let result = [...items];
        const filteringEntries = [];
        Object.entries(appliedFilter).map(entry => {
            const isArrayFilter = isArr(entry[1]);
            if(isArrayFilter){
                return entry[1].length > 0 && filteringEntries.push(entry)
            }else{
                return entry[1] !== null && filteringEntries.push(entry)
            }
        });
        const currentFilters = filteringEntries.length;
        if(currentFilters > 0){
            result = result.map(item => {
                let matchCount = 0;
                filteringEntries.forEach(([name, values]) => {
                    const array = isArr(values);
                    const itemKey = item[name];
                    const shouldBeHidden = array ? values.includes(itemKey) : itemKey === values;
                    shouldBeHidden && matchCount++
                })
                return {...item, hidden: matchCount < currentFilters }
            })
        }else{
            result= result.map(item => {
                return {...item, hidden: false }
            })
        }

        if(priceFilter === "max"){
            result.sort((a, b) => b.price - a.price);
        }

        if(priceFilter === "min"){
            result.sort((a, b) => a.price - b.price);
        }


        return setCardItems(result)

    }, [appliedFilter, items, priceFilter]);

    useEffect(() => {
        let count = 0;
        Object.values(appliedFilter).map(entry => {
            const isArrayFilter = isArr(entry);
            if(isArrayFilter){
                return entry.length > 0 && count++
            }else{
                return entry !== null && count++
            }
        });
        setFiltersCount(count)
    }, [appliedFilter]);

    const clear = useCallback(() => {
        setApliedFilter(filtersFromData);
        toggle();
    },[toggle]);

    return (
        <div className="cardList">
            <div className="cardList-filters">
                <button className={`Filter-btn Filter-price-${priceFilter}`} onClick={handlePriceFilter}>{filters.buttons.price}</button>
                <button className={`Filter-btn Filter-menu`} onClick={toggle}>+ {filters.buttons.openBtn} <span>({filterCount})</span></button>
            </div>
            <Filter
                isOpen={isFilterOpen}
                filter={appliedFilter}
                handleClickOutside={() => isFilterOpen ? toggle() : {}}
                onClose={toggle}
                optionButton={<button className={`Filter-btn Filter-menu`} onClick={toggle}>- {filters.buttons.openBtn} <span>({filterCount})</span></button>}
                options={filters.main}
                onOptionChange={handleOptionClick}
                onClear={clear}
            />
            <div className="cardList-inner">
                <div className="cardList-list">
                    {cardItems.map((item, i) =>
                        <Card key={item.itemId} itemKey={i} {...item} price={formatAmount(item.price)} type={item.type.toString()}/>
                    )}
                </div>
            </div>

        </div>
    )
};

const shouldMemo = (prevProps, nextProps) => prevProps.items.length === nextProps.items.length;
export default memo(CardList, shouldMemo)
